<template>
  <section class="page-container">
    <span class="sub-heading">Investigating {{$store.state.currentGame.quest.name}}</span>
    <div class="investigate-card" v-html="$store.state.currentGame.quest.description"></div>
    <div class="icon-row">
      <icon-buttons back="back" />
    </div>
  </section>
</template>
<script>
import IconButtons from '@/components/IconButtons.vue';
import htmlRenderer from '../../lib/cmsRichTextHtmlRenderer';

export default {
  name: 'QuestInfo',
  components: {
    IconButtons,
  },
  mounted() {
    const { quest } = this.$store.state.currentGame;
    if (typeof quest.description !== 'string') {
      quest.description = htmlRenderer(quest.description);
    }
  },
};
</script>
